module.exports = __webpack_public_path__ + "4159f54f8e8c52956252f7997f16e8e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-23.png
// module id = 2117
// module chunks = 0